import React, { useEffect, useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Link } from 'react-router-dom';
// import { Tilt } from 'react-tilt';
// import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import profile from '../assets/images/profile.jpg';
import ContactSection from '../components/ContactSection';
import axios from 'axios';

const API_URI = process.env.REACT_APP_API_URI || 'http://localhost:5000';
const CloudUrl = process.env.REACT_APP_CLOUD_FLARE_URL;

const services = [
  {
    id: 1,
    title: 'Data Science',
    description: 'Providing comprehensive data analysis and insights to help businesses make informed decisions.',
    icon: '📊',
  },
  {
    id: 2,
    title: 'Machine Learning',
    description: 'Building and deploying machine learning models to automate tasks and improve business operations.',
    icon: '🤖',
  },
  {
    id: 3,
    title: 'Generative AI Product Development',
    description: 'Creating innovative AI-driven products that generate content, design, and solutions.',
    icon: '🧠',
  },
];

// const testimonials = [
//   {
//     id: 1,
//     name: 'Jason Turner',
//     imageUrl: 'https://via.placeholder.com/150',
//     quote: 'When it comes to e-commerce solutions, portfolioxpress is second to none. They transformed our outdated online store into a sleek and user-friendly platform.',
//   },
//   {
//     id: 2,
//     name: 'Amanda Chen',
//     imageUrl: 'https://via.placeholder.com/150',
//     quote: 'portfolioxpress is a digital marketing powerhouse. Their campaigns and data-driven approach have been instrumental in expanding our reach and boosting engagement.',
//   },
//   {
//     id: 3,
//     name: 'Rodriguez',
//     imageUrl: 'https://via.placeholder.com/150',
//     quote: 'I can’t recommend portfolioxpress enough for their exceptional content creation and copywriting skills. Their ability to capture the essence of our brand and translate it into compelling narratives is impressive.',
//   },
// ];

const Home = () => {
  const [projects, setProjects] = useState([]);
  const [blogs, setBlogs] = useState([]);
  const [projectsLoading, setProjectsLoading] = useState(true);
  const [blogsLoading, setBlogsLoading] = useState(true);
  const [projectsError, setProjectsError] = useState(null);
  const [blogsError, setBlogsError] = useState(null);

  const token = localStorage.getItem('token');

  useEffect(() => {
    const authHeaders = token ? { 'Authorization': `Bearer ${token}` } : {};

    const fetchProjects = async () => {
      try {
        const response = await axios.get(`${API_URI}/api/portfolio`, { headers: authHeaders });
        const fetchedProjects = response.data.map(project => ({
          id: project._id,
          title: project.title,
          description: project.description,
          imageUrl: project.images && project.images.length
            ? `${CloudUrl}/${project.images}`
            : '',
          link: `/project/${project._id}`,
        }));
        setProjects(fetchedProjects);
      } catch (error) {
        console.error('Error fetching projects:', error);
        setProjectsError('Failed to load projects.');
      } finally {
        setProjectsLoading(false);
      }
    };

    const fetchBlogs = async () => {
      try {
        const response = await axios.get(`${API_URI}/api/blogs`, { headers: authHeaders });
        const fetchedBlogs = response.data.map(blog => ({
          id: blog._id,
          title: blog.title,
          description: blog.description,
          imageUrl: blog.images && blog.images.length
            ? `${CloudUrl}/${blog.images}`
            : '',
          link: `/blog/${blog._id}`,
        }));
        setBlogs(fetchedBlogs);
      } catch (error) {
        console.error('Error fetching blogs:', error);
        setBlogsError('Failed to load blogs.');
      } finally {
        setBlogsLoading(false);
      }
    };

    fetchProjects();
    fetchBlogs();
  }, [token]);
  
  // const settings = {
  //   dots: true,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   autoplay: true,
  //   autoplaySpeed: 4000,
  //   responsive: [
  //     {
  //       breakpoint: 1024,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //       },
  //     },
  //     {
  //       breakpoint: 600,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //         arrows: false,
  //       },
  //     },
  //   ],
  // };
  
  return (
    <div className="flex flex-col min-h-screen bg-black text-white">
      <main className="flex-grow">
        {/* Project Highlights Section */}
        <section>
          {projectsLoading ? (
            <div className="flex items-center justify-center h-full">
              <p className="text-xl">Loading projects...</p>
            </div>
          ) : projectsError ? (
            <div className="flex flex-col items-center justify-center h-full p-4">
              <p className="text-xl mb-4">{projectsError}</p>
              <button
                className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded transition-all duration-700"
                onClick={() => window.location.reload()}
              >
                Retry
              </button>
            </div>
          ) : projects.length === 0 ? (
            <div className="flex items-center justify-center h-full">
              <p className="text-xl">No projects available at the moment.</p>
            </div>
          ) : (
            <Carousel showThumbs={false} infiniteLoop useKeyboardArrows autoPlay interval={4000}>
              {projects.map((project) => (
                <div key={project.id} className="relative w-full h-64 sm:h-80 md:h-96 lg:h-[500px]">
                  <img src={project.imageUrl} alt={project.title} className="object-cover w-full h-full" />
                  <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col justify-center items-start text-left p-4">
                    <Link to="/portfolio" className="text-[13px] md:text-[15px] mb-2 hover:text-green-500 hover:underline transition-all duration-500">
                      Category: Portfolio
                    </Link>
                    <h3 className="text-1xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-2 hover:text-green-500 transition-all duration-500">
                      <Link to={`/project/${project.id}`}>
                        {project.title}
                      </Link>
                    </h3>
                    <p className="mt-2 text-sm md:text-base">
                      {project.description.length > 100 ? `${project.description.substring(0, 100)}...` : project.description}
                    </p>
                  </div>
                </div>
              ))}
            </Carousel>
          )}
        </section>

        <div className="my-8"></div>

        {/* Blog Highlights Section */}
        <section>
          {blogsLoading ? (
            <div className="flex items-center justify-center h-full">
              <p className="text-xl">Loading blogs...</p>
            </div>
          ) : blogsError ? (
            <div className="flex flex-col items-center justify-center h-full p-4">
              <p className="text-xl mb-4">{blogsError}</p>
              <button
                className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded transition-all duration-700"
                onClick={() => window.location.reload()}
              >
                Retry
              </button>
            </div>
          ) : blogs.length === 0 ? (
            <div className="flex items-center justify-center h-full">
              <p className="text-xl">No blog posts available at the moment.</p>
            </div>
          ) : (
            <Carousel showThumbs={false} infiniteLoop useKeyboardArrows autoPlay interval={4000}>
              {blogs.map((blog) => (
                <div key={blog.id} className="relative w-full h-64 sm:h-80 md:h-96 lg:h-[500px]">
                  <img src={blog.imageUrl} alt={blog.title} className="object-cover w-full h-full" />
                  <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col justify-center items-start text-left p-4">
                    <Link to="/blog" className="text-[13px] md:text-[15px] mb-2 hover:text-green-500 hover:underline transition-all duration-500">
                      Category: Blogs
                    </Link>
                    <h3 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-2 hover:text-green-500 transition-all duration-500">
                      <Link to={`/blog/${blog.id}`}>
                        {blog.title}
                      </Link>
                    </h3>
                    <p className="mt-2 text-sm md:text-base">
                      {blog.description.length > 100 ? `${blog.description.substring(0, 100)}...` : blog.description}
                    </p>
                  </div>
                </div>
              ))}
            </Carousel>
          )}
        </section>

        <div className="border-t border-gray-700 my-8"></div>

        {/* Services Section */}
        <section className="bg-black text-white p-8">
          <h2 className="text-4xl md:text-5xl font-bold mb-8 text-center">Services</h2>
          <div className="container mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {services.map((service) => (
                <div key={service.id} className="flex flex-col items-start p-4 bg-gray-800 rounded-lg shadow-md hover:bg-gray-700 hover:scale-105 transition-all duration-500 transform">
                  <div className="text-4xl mb-4">{service.icon}</div>
                  <h3 className="text-3xl md:text-4xl font-bold mb-2">{service.title}</h3>
                  <p className="text-lg md:text-xl">{service.description}</p>
                </div>
              ))}
            </div>
            <div className="mt-8 text-right">
              <Link to="/services" className="text-lg md:text-xl text-green-500 hover:underline">
                Find Out More...
              </Link>
            </div>
          </div>
        </section>

              {/* Testimonial Section
      <section className="bg-black text-white p-8">
        <h2 className="text-4xl md:text-5xl font-bold mb-8 text-center">From My Clients</h2>
        <div className="container mx-auto">
          <Slider {...settings}>
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="px-4">
                <Tilt className="Tilt" options={{ max: 25 }}>
                  <div className="flex flex-col items-center p-8 bg-gray-800 rounded-lg shadow-md hover:bg-gray-700 transition-all duration-500 transform hover:scale-105 h-64 md:h-80 sm:h-64">
                    <div className="mb-4">
                      <img
                        src={testimonial.imageUrl ? `${CloudUrl}/${testimonial.imageUrl}` : 'https://via.placeholder.com/150'}
                        alt={testimonial.name}
                        className="w-24 h-24 object-cover rounded-full"
                      />
                    </div>
                    <p className="text-lg md:text-xl italic mb-4">"{testimonial.quote}"</p>
                    <h3 className="text-lg md:text-xl font-bold">{testimonial.name}</h3>
                  </div>
                </Tilt>
              </div>
            ))}
          </Slider>
        </div>
      </section> */}

        <div className="border-t border-gray-700 my-8"></div>

        {/* Contact Section */}
        <ContactSection />

        <div className="border-t border-gray-700 my-8"></div>

        {/* About Me Section */}
        <section className="bg-black text-white p-8">
          <h2 className="text-4xl md:text-5xl font-bold mb-8 text-center">About Me</h2>
          <div className="container mx-auto max-w-4xl text-center">
            <img 
              src={profile} 
              alt="Amit Kedia" 
              className="w-32 h-32 rounded-full mx-auto mb-4"
            />
            <p className="text-lg md:text-xl mb-4">
              Hello! I am Amit Kedia, a passionate Data Scientist and Machine Learning Engineer with extensive experience in Generative AI Product Development, BI dashboards, Report Writing, and Research. I am dedicated to leveraging data-driven insights to drive business growth and innovation.
            </p>
            <p className="text-lg md:text-xl">
              With a strong background in data analysis and machine learning, I have successfully completed numerous projects that have helped businesses make informed decisions and improve their operations. Let's work together to turn data into actionable insights and innovative solutions.
            </p>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Home;